
	import {
		Component,
		Vue
	} from 'vue-property-decorator';

	import {
		rolelist,
		employeeList,
		employeeResign,
		employeeResetPwd,
		employeeisHaveFreightSettlementTemplateLimit,
		employeeisHaveExportOrderListCostPriceLimit,
	} from '@/api/auth';

	import PageFooter from '@/components/page-footer.vue';
	import addEmployee from './components/add-employee.vue';
	import allotProvider from './components/allot-provider.vue';

	@Component({
		name: 'auth-roles',
		components: {
			PageFooter,
			addEmployee,
			allotProvider
		}
	})
	export default class AuthRoles extends Vue {

		private showDialog = false;
		private employeeId = 0;
		
		private showAllot = false;

		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private list: any = [];

		private keywords = '';
		private roleId = null;
		private roleList = [];
		private state = 0;
		private stateList = [
			{
				id: null,
				label: '全部'
			}, {
				id: 0,
				label: '在职'
			}, {
				id: 1,
				label: '离职'
			}
		];

		private mounted() {
			this.getRoleList();
			this.getList();
		}

		private async changeHasCostPrice(e,row){
			try{
				let res = await employeeisHaveExportOrderListCostPriceLimit({
					EmployeeId:row.Id,
					IsHaveExportOrderListCostPriceLimit:e
				})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.getList()
				}
			}finally{
				//
			}
		}
		private async changeShowbutton(e,row){
			try{
				let res = await employeeisHaveFreightSettlementTemplateLimit({
					EmployeeId:row.Id,
					IsHaveFreightSettlementTemplateLimit:e
				})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.getList()
				}
			}finally{
				//
			}
		}
		//新增成员
		private toCreate() {
			this.employeeId = 0;
			this.showDialog = true;
		}
		//编辑成员
		private handleEdit(record:any) {
			this.employeeId = record.Id;
			this.showDialog = true;
		}

		// 分页
		private changePage(e:any) {
			this.pageNo = e;
			this.getList();
		}

		//搜索
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		//清空
		private clearSearch() {
			this.roleId = null;
			this.state = null;
			this.keywords = '';

			this.getList();
		}

		//离职
		private handleChangeState(record:any) {

			this.$confirm('离职后无法用账号登录系统', '提示', {
				confirmButtonText: '确认离职',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				try {
					const res: any = await employeeResign({
						Id: record.Id
					})
					this.$message.success('操作成功');
					this.getList();
				} catch (err) {}
			}).catch(() => {
			});
			
		}
		
		//重置密码
		private handleResetPassword(record:any){
			this.$confirm('重置后密码为123456', '提示', {
				confirmButtonText: '确认重置',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				try {
					const res: any = await employeeResetPwd({
						Id: record.Id
					})
					this.$message.success('操作成功');
					this.getList();
				} catch (err) {}
			}).catch(() => {
			});
		}

		//获取员工列表
		private async getList() {
			try {
				const res: any = await employeeList({
					Skip: (this.pageNo - 1) * this.pageSize,
					Take: this.pageSize,
					KeyWords: this.keywords,
					EmployeeRoleId: this.roleId,
					EmployeeState: this.state
				})
				this.total = res.Result.Total;
				this.list = res.Result.Results;
			} catch (err) {}
		}

		//获取角色列表
		private async getRoleList() {
			try {
				const res: any = await rolelist({
					Skip: 0,
					Take: 99999
				})
				this.roleList = res.Result.Results;
			} catch (err) {}
		}
		
		/**
		 * 分配供应商
		 */
		private handleAllot(record:any){
			this.employeeId = record.Id;
			this.showAllot = true;
		}

	}
